webpackJsonp([185885681872205],{

/***/ 157:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	__webpack_require__(157);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _util = __webpack_require__(12);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // STYLES
	
	
	//LIBS
	
	
	// HELPERS
	
	
	// INTERFACE
	var FAQItem = function (_React$Component) {
	  _inherits(FAQItem, _React$Component);
	
	  function FAQItem(props) {
	    _classCallCheck(this, FAQItem);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.toggleExpanded = function () {
	      //Opens and closes the answer drop-downs 
	      _this.setState(function (state) {
	        return { expanded: !state.expanded };
	      });
	    };
	
	    _this.captureTarget = function () {
	      //On click pass the jumpLinkTarget element #id to the parent component's state
	      _this.props.setExpandedTarget(_this.props.jumpLinkTarget);
	    };
	
	    _this.state = {
	      expanded: (_this.props.id === 'computer-requirements' && typeof window !== 'undefined' ? window.location.href.includes('#computer-requirements') ? true : false : false) || (_this.props.id === 'ops-kit-requirements' && typeof window !== 'undefined' ? window.location.href.includes('#ops-kit-requirements') ? true : false : false) || (_this.props.id === 'textbook-requirements' && typeof window !== 'undefined' ? window.location.href.includes('#textbook-requirements') ? true : false : false),
	      target: ''
	    };
	    return _this;
	  }
	
	  FAQItem.prototype.componentDidUpdate = function componentDidUpdate() {
	    //On mount check to see if this component has an id or expandedTarget defined, if so and they match and the answer is not already expanded, expand the answer and clear the jumpLinkTarget. If it is already expanded, then toggle the expanded state so it is ready to close on subsequent click.
	    if (this.props.id === this.props.expandedTarget && this.props.id && this.props.expandedTarget) {
	      if (this.state.expanded === false) {
	        this.props.setExpandedTarget('');
	        this.toggleExpanded();
	      } else {
	        this.toggleExpanded();
	      }
	    }
	  };
	
	  FAQItem.prototype.render = function render() {
	    var _this2 = this;
	
	    //id = element #id | q = question | a = answer | jumpLinkTarget = target element #id
	    var _props = this.props,
	        id = _props.id,
	        q = _props.q,
	        a = _props.a,
	        jumpLinkTarget = _props.jumpLinkTarget;
	
	
	    if (id || jumpLinkTarget) {
	      if (id) {
	        //If the FAQItem has an id, add styling to allow it to be displayed correctly when navigated to from a link in another answer
	        return _react2.default.createElement(
	          'div',
	          { className: 'FAQItem' },
	          _react2.default.createElement('div', { id: id, className: 'jump-target-adjustment' }),
	          _react2.default.createElement(
	            'h4',
	            { style: { cursor: 'pointer' }, onClick: function onClick() {
	                _this2.toggleExpanded();
	              } },
	            ' ',
	            q,
	            ' '
	          ),
	          util.renderIf(this.state.expanded, _react2.default.createElement('div', { className: 'answer', dangerouslySetInnerHTML: { __html: a } }))
	        );
	      } else {
	        //If the FAQItem has an jumpLinkTarget, update the answer content to add the anchor link. Must render the answer contents from faq/index.js separately from the anchor link and onClick. dangerouslySetInnerHTML can only handle one element and the onClick must be outside of it to function properly.
	        return _react2.default.createElement(
	          'div',
	          { className: 'FAQItem' },
	          _react2.default.createElement(
	            'h4',
	            { style: { cursor: 'pointer' }, onClick: function onClick() {
	                _this2.toggleExpanded();
	              } },
	            ' ',
	            q,
	            ' '
	          ),
	          util.renderIf(this.state.expanded, _react2.default.createElement(
	            'div',
	            { className: 'answer answer-link-left' },
	            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: a } })
	          )),
	          util.renderIf(this.state.expanded, _react2.default.createElement(
	            'div',
	            { className: 'answer answer-link-right' },
	            _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: '&nbsp;<a href="#' + jumpLinkTarget + '">here</a>.' }, onClick: this.captureTarget })
	          ))
	        );
	      }
	    } else {
	      //If the FAQItem does not have an id or jumpLinkTarget, render as normal
	      return _react2.default.createElement(
	        'div',
	        { className: 'FAQItem' },
	        _react2.default.createElement(
	          'h4',
	          { style: { cursor: 'pointer' }, onClick: function onClick() {
	              return _this2.toggleExpanded();
	            } },
	          ' ',
	          q,
	          ' '
	        ),
	        util.renderIf(this.state.expanded, _react2.default.createElement('div', { className: 'answer', dangerouslySetInnerHTML: { __html: a } }))
	      );
	    }
	  };
	
	  return FAQItem;
	}(_react2.default.Component);
	
	exports.default = FAQItem;
	module.exports = exports['default'];

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _faqItem = __webpack_require__(115);
	
	var _faqItem2 = _interopRequireDefault(_faqItem);
	
	var _metaData = __webpack_require__(14);
	
	var _metaData2 = _interopRequireDefault(_metaData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// INTERFACE
	
	
	// COMPONENTES
	var GIBillFAQPage = function GIBillFAQPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'custom_pages' },
	    _react2.default.createElement(_metaData2.default, { data: {
	        slug: 'gi-bill-faq',
	        title: 'GI Bill FAQs',
	        description: 'Code Fellows GI Bill FAQs'
	      } }),
	    _react2.default.createElement(
	      'div',
	      { className: 'custom-page-header', style: {
	          background: '#777',
	          backgroundImage: "url('https://images.ctfassets.net/qjy3jg1udcmq/4Fe8yd9BSwwQagqKIAUUkg/7a30bf9cd3467bbdade9ed9a727825e1/ow-to-test-into-code-401.jpg')",
	          backgroundPosition: 'center center',
	          backgroundRepeat: 'no-repeat',
	          backgroundSize: 'cover'
	        } },
	      _react2.default.createElement(
	        'h1',
	        { style: { color: 'white' } },
	        'GI Bill\xAE FAQs'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container', style: { padding: '16px 0 36px 0' } },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-8 col-md-offset-2' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              'Are you a veteran who is looking for the best way to fund your coding bootcamp education? We\'re here to help! We\'ve included our most frequent questions below to equip you with the knowledge you need to use your GI Bill\xAE wisely.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Our Military Program Manager is also on hand to walk you through the process once you\'re ready to apply.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_faqItem2.default, {
	              q: 'Does Code Fellows accept the GI Bill\xAE?',
	              a: '<p>Yes we do! We are proud to be the first code school in Washington to accept the GI Bill\xAE. Technically, we accept a litany of VA benefits\u2014Post 9/11 GI Bill\xAE, Montgomery GI Bill\xAE, Vocational Rehabilitation (federal and state), and Dependents Educational Assistance. Over 100 veterans have used their benefits at Code Fellows.</p> <p>You can use your GI Bill\xAE to pay for the 201, 301, and 401 classes. At this time, the GI Bill\xAE cannot be used for the 101, 102, or 501 classes (approval pending with the VA for the 501 classes).</p>'
	            }),
	            _react2.default.createElement(_faqItem2.default, {
	              q: 'How much tuition is covered by the GI Bill\xAE?',
	              a: '<p>The GI Bill\xAE covers 100 percent of Code 201, Code 301, and Code 401 tuition (provided you have 100 percent of the Post 9/11 GI Bill\xAE\u2014if not, it\u2019s the prorated percent). The days and nights program are considered full time for the VA.</p> <p>If you are on the Montgomery GI Bill\xAE or other funding sources, <a href="https://learn.codefellows.org/contact?utm_audience=students&utm_promo_code=not_applicable&utm_sequence_type=not_applicable&utm_partner=0016100000M954d&utm_source=gi_bill_faq_page-gi_bill_tuition_coverage&utm_medium=website&utm_content=gi_bill_faq_page-gi_bill_tuition_coverage&utm_campaign=gi_bill&utm_term=not_applicable&utm_campaign_id=not_applicable&utm_ad_id=not_applicable&utm_adset_id=not_applicable&utm_adset_name=not_applicable&utm_placement=not_applicable&utm_start=not_applicable&utm_cost=organic" target="_blank">get in touch</a> and we\u2019ll walk you through the details.</p> <p>Please note that there is an annual cap to the GI Bill\xAE. From Aug. 1 to July 31, a student may use up to $24,476.79 (adjusted annually on Aug. 1). The Code 201\u2014Code 401 sequence costs $22,000 (regardless of whether you enroll in the daytime track or nights & weekends track), so 11 months and 4 days of benefits will be used during that time.</p>'
	            }),
	            _react2.default.createElement(_faqItem2.default, {
	              q: 'Will I qualify for the housing allowance, and how much is it?',
	              a: '<p>Yes, if you use your GI Bill\xAE for Code 201, Code 301, or Code 401 at Code Fellows (whether in the Daytime or Nights & Weekends track), you will receive $2,505 per month (prorated for partial months), updating each August. The housing allowance is usually paid on the first of the month for the month prior (e.g., October 1 if you started classes Sept 5). However, if you start classes late in the month (after the 16th), you may have a delay in receiving the housing allowance.</p>'
	            }),
	            _react2.default.createElement(_faqItem2.default, {
	              q: 'How much is the book stipend?',
	              a: '<p>The book stipend is $1000 per year, prorated and paid each month for the number of days the course covers, and dependent on your eligibility percentage.</p>'
	            }),
	            _react2.default.createElement(_faqItem2.default, {
	              q: 'Are the classes in sequence or will there be a break in my housing allowance?',
	              a: '<p>Generally, we run the 201, 301 and 401 in sequence with a one week break in between. Your housing allowance will \u201Cturn off\u201D during this one week break (because you are not certified as a student during that time). You may also have a break if you are waiting for a certain 401 course (for example, Python does not happen as often as JavaScript).</p>'
	            }),
	            _react2.default.createElement(_faqItem2.default, {
	              q: 'How do I use my GI Bill\xAE at Code Fellows?',
	              a: '<p>When you apply, be sure to tell us that you\u2019d like to use those benefits and our Admissions team will help you navigate.Our Military Program Manager is also available to help. You\u2019ll <a href="http://benefits.va.gov/gibill/apply.asp" target="_blank">apply to use your benefits with the VA</a>. If you\u2019ve used your GI Bill\xAE at another school, you will fill out the form to change schools (VA Form 1995) and designate "Code Fellows".</p>'
	            }),
	            _react2.default.createElement(_faqItem2.default, {
	              q: 'How long does it take to get approved by the VA?',
	              a: '<p>It usually takes two to three weeks to be approved by the VA, but it can take up to 30 days (processing times run longer during spring and fall). You\u2019ll receive a Certificate of Eligibility (CoE) in the mail and you can send that to <a href=" mailto:veterans@codefellows.com">veterans@codefellows.com</a> or mail it to our office with Attn: Military Program. The Education Enrollment Status is available online (via ebenefits) and can be used instead of the CoE. We need something official that shows your months remaining of benefits and the benefit level (it will be up to 100%).</p> <p><strong>This part is important</strong>: be sure that you <a href="https://learn.codefellows.org/apply-now?utm_audience=students&utm_promo_code=not_applicable&utm_sequence_type=not_applicable&utm_partner=0016100000M954d&utm_source=gi_bill_faq_page-va_approval&utm_medium=website&utm_content=gi_bill_faq_page-va_approval&utm_campaign=gi_bill&utm_term=not_applicable&utm_campaign_id=not_applicable&utm_ad_id=not_applicable&utm_adset_id=not_applicable&utm_adset_name=not_applicable&utm_placement=not_applicable&utm_start=not_applicable&utm_cost=organic" target="_blank">apply for our program</a> and for your benefits <strong>at the same time</strong>. Each process can take a few weeks, so get them going. Don\u2019t wait for one to be complete before you start the other. We require all documents to use your GI Bill\xAE three weeks prior to the class start date.</p>'
	            }),
	            _react2.default.createElement(_faqItem2.default, {
	              q: 'Can Code Fellows tell me how many months of benefits I have left?',
	              a: '<p>Unfortunately, we don\u2019t have access to that information. To find out how many months of benefits you have left, you can call the VA Education Call Center at 1-888-442-4551. Don\u2019t worry about getting stuck on hold\u2014you can schedule a call back (ASAP or at a certain time). The call center is available 7 a.m. to 6 p.m., central time (Muskogee, OK).</p>'
	            }),
	            _react2.default.createElement(_faqItem2.default, {
	              q: 'What if I don\u2019t have enough GI Bill\xAE benefits to pay for classes?',
	              a: '<p>Veterans are encouraged to apply for a <a href="/scholarship-fund/" target="_blank">Scholarship</a> if they don\u2019t have enough funding from the VA to cover tuition. Code Fellows has awarded more than $1.2M in scholarships, including many scholarships to veterans. Please discuss this with us as running out of benefits will also impact your housing allowance.</p>'
	            }),
	            _react2.default.createElement(_faqItem2.default, {
	              q: 'Are there other funding sources to decrease the cost?',
	              a: '<p>Yes! Code Fellows also qualifies for the Worker Retraining Program\u2014this can pay for about 15% of your tuition if you are eligible (i.e., WA resident, separated from military within the last 48 months, and unemployed). This funding gets applied to your tuition prior to your GI funding, which saves you some of your benefits. Ask your admissions advisor about this program when you apply. If you have a service connected disability, you may be eligible for vocational rehabilitation funding as well.</p>'
	            }),
	            _react2.default.createElement(_faqItem2.default, {
	              q: 'Are there other resources for the military community??',
	              a: '<p>Check out <a href="https://operationcode.org/" target="_blank">Operation Code</a>, a national nonprofit (with a strong presence in Seattle) that helps the military community transition into the tech sector. They provide mentors, scholarships to conferences, and job search help.</p>'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'h2',
	              { style: { fontSize: '1.3em', fontWeight: 'bold' } },
	              'Additional questions'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Don\u2019t see the answer to your question? Check out our ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.codefellows.org/faq/', target: '_blank' },
	                'general FAQ page'
	              ),
	              ' or ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://learn.codefellows.org/contact?utm_audience=students&utm_promo_code=not_applicable&utm_sequence_type=not_applicable&utm_partner=0016100000M954d&utm_source=gi_bill_faq_page-additional_questions&utm_medium=website&utm_content=gi_bill_faq_page-additional_questions&utm_campaign=gi_bill&utm_term=not_applicable&utm_campaign_id=not_applicable&utm_ad_id=not_applicable&utm_adset_id=not_applicable&utm_adset_name=not_applicable&utm_placement=not_applicable&utm_start=not_applicable&utm_cost=organic' },
	                'get in touch'
	              ),
	              '!'
	            )
	          )
	        )
	      )
	    )
	  );
	}; // LIBS
	exports.default = GIBillFAQPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-gi-bill-faq-index-js-220663e54a02b23ff06c.js